import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RefundItemsFormComponent, RefundItemsFormDataBuilderInterface } from '@lib/shared';
import { FormBuilder } from './form.builder';

@Component({ standalone: false, selector: 'app-refund-items-form-component', templateUrl: './refund.component.html' })
export class CustomRefundComponent extends RefundItemsFormComponent implements OnInit {
  getFormGroup(data: RefundItemsFormDataBuilderInterface): FormGroup {
    return new FormBuilder().getForm(data);
  }
}
